import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/layout/sidebar/icons/manajemen_login_&_perangkat.svg'


const _hoisted_1 = {
  class: "bg-yellow-lp-500 p-2 flex items-start justify-between rounded-xl gap-x-4",
  style: {"width":"387px"}
}
const _hoisted_2 = { class: "flex items-start gap-x-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-8 flex-shrink-0 pt-2.5",
  alt: "login"
}, null, -1)
const _hoisted_4 = { class: "flex flex-col gap-y-1 text-white" }
const _hoisted_5 = { class: "text-white text-base font-bold" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "underline" }, "Lihat", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.data.title), 1),
        _createVNode("div", {
          class: "text-white text-sm",
          innerHTML: _ctx.data.message
        }, null, 8, ["innerHTML"])
      ])
    ]),
    (_ctx.data.onAction)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          class: "flex items-center space-x-1 text-sm text-white font-bold pt-2.5",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.data.onAction && _ctx.data.onAction(...args)))
        }, [
          _hoisted_6,
          _createVNode(_component_Icons, {
            name: "chevron-right",
            class: "w-2"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}